import { hasPermission } from "@helpers/session";
import { useUserStore } from "@stores/userStore";

const items = [
    {
        dashboard: false,
        hidden_on_dashboard: true,
        icon: "fa-home",
        label: "Dashboard",
        permission: false,
        route: { name: "/" },
    },
    {
        customer: true,
        disabled: false,
        hidden_on_dashboard: true,
        icon: "fa-home",
        label: "Dashboard",
        permission: "customer",
        route: { name: "/" },
    },
    {
        disabled: false,
        icon: "fa-users",
        label: "Klanten",
        permission: "crm.general.view",
        route: { name: "/crm/customers" },
    },
    {
        disabled: false,
        icon: "fa-shopping-cart",
        label: "Opdrachten",
        permission: "beta",
        route: { name: "/order" },
    },
    {
        icon: "fa-grid-2",
        label: "Projecten",
        permission: "project.view",
        route: { name: "/project" },
    },
    {
        childeren: [
            {
                disabled: false,
                icon: "fa-plug",
                label: "Apparaten",
                permission: "device.view",
                route: { name: "/devicemanagement/device" },
            },
            {
                disabled: false,
                icon: "fa-object-group",
                label: "Apparaatgroepen",
                permission: "device.group.view",
                route: { name: "/devicemanagement/devicegroup" },
            },
            {
                disabled: false,
                icon: "fa-file-pen",
                label: "Handmatige registratie",
                permission: "temperature.manual",
                route: { name: "/devicemanagement/temperature/register/manual" },
            },
            {
                disabled: false,
                icon: "fa-chart-line",
                label: "Resultaten",
                permission: "temperature.results.view",
                route: { name: "/devicemanagement/temperature/result" },
            },
            {
                disabled: false,
                icon: "fa-list-check",
                label: "Resultaten goedkeuren",
                permission: "temperature.results.approve",
                route: {
                    name: "/devicemanagement/temperature/approve",
                },
            },
            {
                disabled: false,
                icon: "fa-message-exclamation",
                label: "Temperatuur afwijk redenen",
                permission: "temperature.deviationreason.view",
                route: { name: "/devicemanagement/temperature/deviation-reason" },
            },
            {
                disabled: false,
                icon: "fa-spinner",
                label: "Temperatuur rondes",
                permission: "temperature.round.view",
                route: { name: "/devicemanagement/temperature/round" },
            },
            {
                disabled: false,
                icon: "fa-truck",
                label: "Leveranciers",
                permission: "device.manufacturer.view",
                route: {
                    name: "/system/configuration/device/manufacturer",
                },
            },
            {
                disabled: false,
                icon: "fa-plug",
                label: "Apparaat types",
                permission: "device.type.view",
                route: { name: "/system/configuration/device/type" },
            },
        ],
        disabled: false,
        icon: "fa-plug",
        label: "Apparaatbeheer",
    },
    {
        childeren: [
            {
                disabled: false,
                icon: "fa-tags",
                label: "Activiteiten",
                permission: "work.activity.view",
                route: { name: "/time-tracking/activity" },
            },
            {
                disabled: false,
                icon: "fa-plus",
                label: "Nieuwe dienst",
                permission: "work.shift.create",
                route: {
                    name: "/time-tracking/shift/[id]/edit",
                    params: { id: "new" },
                },
            },
            {
                disabled: false,
                icon: "fa-business-time",
                label: "Diensten",
                permission: "work.shift.overview",
                route: { name: "/time-tracking/shift" },
            },
        ],
        disabled: false,
        icon: "fa-clock",
        label: "Tijdregistratie",
    },
    {
        childeren: [
            {
                disabled: false,
                icon: "fa-files",
                label: "Koppelingen (FTP)",
                permission: "beta",
                route: { name: "/labhub/ftp-communication" },
            },
        ],
        disabled: false,
        icon: "fa-flask-vial",
        label: "LabHub",
        permission: "beta",
    },
    {
        childeren: [
            {
                disabled: false,
                icon: "fa-book",
                label: "Kwaliteithandboek",
                permission: "document.qualityhandbook.view",
                route: { name: "/document/qualityhandbook/category" },
            },
        ],
        disabled: false,
        icon: "fa-files",
        label: "Documenten",
        permission: false,
    },
    {
        childeren: [
            {
                disabled: false,
                icon: "fa-list-check",
                label: "Contracten goedkeuren",
                permission: "finance.contract.approve",
                route: { name: "/finance/contract/approve" },
            },
            {
                disabled: false,
                icon: "fa-briefcase",
                label: "Product portfolio",
                permission: "productportfolio.view",
                route: { name: "/productportfolio" },
            },
            // {
            //     disabled: true,
            //     icon: "fa-file-contract",
            //     label: "Contracten vergelijken",
            //     permission: "beta",
            //     route: {name: "temperatureSelectDeviceView"},
            // },
            {
                disabled: false,
                icon: "fa-chart-line",
                label: "Omzet cijfers",
                permission: "finance.revenue.view",
                route: { name: "/finance/revenue" },
            },
            {
                disabled: false,
                icon: "fa-sharp fa-solid fa-money-check-dollar-pen",
                label: "Prijswijzigingen",
                permission: "finance.pricechange",
                route: { name: "/finance/pricechange" },
            },
            {
                disabled: false,
                icon: "fa-pen-swirl",
                label: "Contracten updaten",
                permission: "finance.contract.edit",
                route: { name: "/finance/contract/update" },
            },
        ],
        disabled: false,
        icon: "fa-money-bill-trend-up",
        label: "Sales",
    },
    {
        childeren: [
            {
                disabled: false,
                icon: "fa-layer-plus",
                label: "Factuur item klaarzetten",
                permission: "finance.invoice.schedule",
                route: {
                    name: "/finance/invoice/scheduled-item/[id]/edit",
                    params: { id: "new" },
                },
            },
            {
                disabled: false,
                icon: "fa-layer-group",
                label: "Klaargezette factuur items",
                permission: "finance.invoice.schedule",
                route: { name: "/finance/invoice/scheduled-item" },
            },
            {
                disabled: false,
                icon: "fa-file-circle-plus",
                label: "Nieuwe factuur maken",
                permission: "finance.invoice.edit",
                route: { name: "/finance/invoice/create" },
            },
            {
                disabled: false,
                icon: "fa-list-check",
                label: "Facturen controleren",
                permission: "finance.invoice.edit",
                route: {
                    name: "/finance/invoice",
                    query: { search: JSON.stringify({ status: "pending_approval" }) },
                },
            },
            {
                disabled: false,
                icon: "fa-circle-check",
                label: "Facturen vrijgeven",
                permission: "finance.invoice.approve",
                route: {
                    name: "/finance/invoice",
                    query: { search: JSON.stringify({ status: "pending_manager_approval" }) },
                },
            },
            {
                disabled: false,
                icon: "fa-list",
                label: "Factuur overzicht",
                permission: "finance.invoice.view",
                route: { name: "/finance/invoice" },
            },
            {
                disabled: false,
                icon: "fa-filter",
                label: "Factuur status checker",
                permission: "finance.invoice.view",
                route: { name: "/finance/invoice/status-checker" },
            },
            {
                disabled: false,
                icon: "fa-calendar-days",
                label: "Factuur weeknummers",
                permission: "finance.invoice.view",
                route: { name: "/finance/invoice/schedule" },
            },
        ],
        disabled: false,
        icon: "fa-file-invoice-dollar",
        label: "Facturatie",
        permission: "finance.invoice.view",
    },
    {
        childeren: [
            {
                disabled: false,
                icon: "fa-list",
                label: "Bezoeken",
                permission: "vdm.visit.view",
                route: { name: "/vdm/visit" },
            },
            {
                disabled: false,
                icon: "fa-jar",
                label: "Monsternames",
                permission: "vdm.sampling.view",
                route: { name: "/vdm/sampling" },
            },
            {
                disabled: false,
                icon: "fa-location-dot",
                label: "Locaties",
                permission: "vdm.location.view",
                route: { name: "/vdm/location" },
            },
            {
                disabled: false,
                icon: "fa-users",
                label: "Klanten",
                permission: "vdm.customer.view",
                route: { name: "/vdm/customer" },
            },
        ],
        disabled: false,
        icon: "fa-shovel-snow",
        label: "VMM",
    },
    // {
    //     disabled: true,
    //     icon: "fa-people-group",
    //     label: "Mijn team",
    //     permission: "beta",
    //     route: {name: "about"},
    // },

    {
        childeren: [],
        disabled: false,
        icon: "fa-flask-vial",
        label: "LabHub",
        permission: false,
    },
    {
        icon: "fa-file-chart-pie",
        label: "Rapportages",
        permission: "report.view.*",
        route: { name: "/report" },
    },
    {
        childeren: [
            {
                disabled: false,
                icon: "fa-monitor-waveform",
                label: "Monitoring",
                permission: "admin.settings.view",
                route: { name: "/system/monitoring" },
            },
            {
                disabled: false,
                icon: "fa-cogs",
                label: "Configuratie",
                permission: "admin.settings.view",
                route: { name: "/system/configuration" },
            },
            {
                disabled: false,
                icon: "fa-database",
                label: "Data manager",
                permission: "admin.settings.view",
                route: { name: "/system/datamanager" },
            },
            {
                disabled: false,
                icon: "fa-buildings",
                label: "Building manager",
                permission: "admin.settings.view",
                route: { name: "/system/buildingmanager" },
            },
            {
                disabled: false,
                icon: "fa-display",
                label: "Display manager",
                permission: "admin.settings.view",
                route: { name: "/system/display" },
            },
        ],
        disabled: false,
        icon: "fa-server",
        label: "Systeem",
        permission: "admin.settings.view",
    },
    {
        customer: true,
        icon: "fa-cart-circle-plus",
        label: "Nieuwe opdracht",
        permission: "customer",
        route: { name: "/orders/new/create" },
    },
    {
        customer: true,
        icon: "fa-cart-shopping",
        label: "Opdrachten",
        permission: "customer",
        route: { name: "/orders" },
    },
    {
        customer: true,
        icon: "fa-grid-2",
        label: "Projecten",
        permission: "customer",
        route: { name: "/projects" },
    },
    // {
    //     childeren: [
    // {
    //     customer: true,
    //     icon: "fa-download",
    //     label: "Downloaden",
    //     permission: "customer",
    //     route: {name: "customer.DownloadResultsView"},
    // },
    // {
    //     customer: true,
    //     icon: "fa-chart-column",
    //     label: "Resultaten",
    //     permission: "customer",
    //     route: {name: "customer.CompareResultsView"},
    // },
    //     ],
    //     customer: true,
    //     icon: "fa-chart-simple",
    //     label: "Resultaten",
    //     permission: "customer",
    // },
    {
        customer: true,
        icon: "fa-solid fa-magnifying-glass-location",
        label: "Meetpunten",
        permission: "customer",
        route: { name: "/samplelocations" },
    },
    {
        customer: true,
        icon: "fa-solid fa-water-ladder",
        label: "Zwembad overzicht",
        permission: "customer",
        route: { name: "/pools" },
    },
    {
        customer: true,
        icon: "fa-solid fa-files",
        label: "Documenten",
        permission: "customer",
        route: { name: "/documents" },
    },
    {
        customer: true,
        disabled: false,
        icon: "fa-wrench",
        label: "Beheer",
        permission: "customer.manager",
        route: { name: "/configurations" },
    },
];

function hasRoutesOrChilderen(tile) {
    if (tile.route) {
        return true;
    }

    if (tile.childeren.length > 0) {
        return true;
    }

    return false;
}

export function getNavItems() {
    // Get userstore
    const userstore = useUserStore();

    // Ensure nav items dont change our base data
    const dataset = JSON.parse(JSON.stringify(items));

    // Filter based on selected customer
    let filtered = dataset.filter((item) => {
        // Tile is a customer tile and a customer is active
        if (item.customer && userstore.getActiveCustomer) {
            return true;
        }

        // Tile is not a customer tile and no customer is active
        if (!item.customer && !userstore.getActiveCustomer) {
            return true;
        }
    });

    // Filter customer tiles
    filtered = filtered.filter((item) => {
        if (item.customer) {
            return hasPermission(item.permission, false);
        }

        return true;
    });

    // Filter main tiles without perms
    filtered = filtered.filter((item) => {
        if (item.permission) {
            return hasPermission(item.permission);
        }

        // Don't remove items without a permission
        return true;
    });

    // Filter child tiles without perms
    filtered.forEach((tile) => {
        if (tile.childeren) {
            tile.childeren = tile.childeren.filter((item) => hasPermission(item.permission));
        }
    });

    // Filter parent tiles without childeren
    filtered = filtered.filter((item) => hasRoutesOrChilderen(item));

    return filtered;
}
